var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDtraderIcon = function SvgDtraderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF444F",
    d: "M5.982 0H25.92a5.982 5.982 0 0 1 5.981 5.982V25.92a5.982 5.982 0 0 1-5.981 5.981H5.98A5.982 5.982 0 0 1 0 25.921V5.98A5.982 5.982 0 0 1 5.982.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.826 5.982 6.76 9.312l5.324 6.55-5.334 6.49.858 3.569 8.264-10.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.393 5.982H9.45l2.484 3.05h3.448a6.979 6.979 0 0 1 6.839 6.98 6.98 6.98 0 0 1-6.839 6.978h-3.734l-2.41 2.93h6.144c5.449-.06 9.82-4.52 9.77-9.969.05-5.445-4.315-9.903-9.76-9.97"
  }))));
};

export { SvgDtraderIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkY0NDRGIiBkPSJNNS45ODIgMEgyNS45MmE1Ljk4MiA1Ljk4MiAwIDAxNS45ODEgNS45ODJWMjUuOTJhNS45ODIgNS45ODIgMCAwMS01Ljk4MSA1Ljk4MUg1Ljk4QTUuOTgyIDUuOTgyIDAgMDEwIDI1LjkyMVY1Ljk4QTUuOTgyIDUuOTgyIDAgMDE1Ljk4Mi4wMDIiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNNy44MjYgNS45ODJMNi43NiA5LjMxMmw1LjMyNCA2LjU1LTUuMzM0IDYuNDkuODU4IDMuNTY5IDguMjY0LTEwLjA1eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xNS4zOTMgNS45ODJIOS40NWwyLjQ4NCAzLjA1aDMuNDQ4YTYuOTc5IDYuOTc5IDAgMDE2LjgzOSA2Ljk4IDYuOTggNi45OCAwIDAxLTYuODM5IDYuOTc4aC0zLjczNGwtMi40MSAyLjkzaDYuMTQ0YzUuNDQ5LS4wNiA5LjgyLTQuNTIgOS43Ny05Ljk2OS4wNS01LjQ0NS00LjMxNS05LjkwMy05Ljc2LTkuOTciLz48L2c+PC9zdmc+";